import React from "react";
import Footer from "./footer";

function About() {
  return (
    <div className="h-full w-full bg-black pt-10 text-white">
    <div className="block text-center text-3xl font-semibold border-b-2 border-green-500 pb-10">Tech I Use</div>
    <div className="flex justify-center">
      <div class="grid grid-cols-2 gap-16 md:grid-cols-4    pb-48 ">
        <div class="md:p-20"><img className=" h-24 w-24 " src="./resources/1.png" alt="head"/></div>
        <div class="md:p-20"><img className=" h-24 w-24 " src="./resources/2.png" alt="head"/></div>
        <div class="md:p-20"><img className=" h-24 w-24 " src="./resources/3.png" alt="head"/></div>
        <div class="md:p-20"><img className=" h-24 w-24 " src="./resources/4.png" alt="head"/></div>
        <div class="md:p-20"><img className=" h-24 w-24 " src="./resources/5.png" alt="head"/></div>
        <div class="md:p-20"><img className=" h-24 w-24 " src="./resources/6.png" alt="head"/></div>
        <div class="md:p-20"><img className=" h-24 w-24 " src="./resources/7.png" alt="head"/></div>
        <div class="md:p-20"><img className=" h-24 w-24 " src="./resources/8.png" alt="head"/></div>
        <div class="md:p-20"><img className=" h-24 w-24 " src="./resources/9.png" alt="head"/></div>
        <div class="md:p-20"><img className=" h-24 w-24 " src="./resources/10.png" alt="head"/></div>
        <div class="md:p-20"><img className=" h-24 w-24 " src="./resources/11.png" alt="head"/></div>
        <div class="md:p-20"><img className=" h-24 w-24 " src="./resources/14.png" alt="head"/></div>
      </div>  
      </div>
      <div  className="flex justify-center">
      <Footer/>
      </div>
    </div>
  );
}

export default About;
